"use strict";

var debug = require("debug")("knack.formatter.formatters.multipleChoice");
var _ = require("lodash");

/**
 * @alias "formatters.multipleChoice"
 * @param {String} value
 * @return {String}
 */
var multipleChoiceFormatter = function multipleChoiceFormatter(value) {
  if (_.isArray(value)) {
    return value.join(", ");
  }
  return value;
};
module.exports = multipleChoiceFormatter;